import Image from 'next/image'
import Link from 'next/link'
import { Routes } from 'src/utils/routes'
import styles from './style.module.scss'

const CtaBanner = () => {
  return (
    <div className={styles.ctaBanner}>
      <Link href={Routes.PASS_REQUEST}>
        <a className={styles.ctaBannerImage} data-media="pc">
          <Image
            src="/images/banner_cta_pc.png"
            width={1000}
            height={273}
            priority={false}
            data-media="pc"
            alt="ワフパスで滞在中にお得な特典を利用しよう! ワフパス発行する"
          />
        </a>
      </Link>
      <Link href={Routes.PASS_REQUEST}>
        <a className={styles.ctaBannerImage} data-media="sp">
          <Image
            src="/images/banner_cta_sp.png"
            width={375}
            priority={false}
            height={369}
            alt="ワフパスで滞在中にお得な特典を利用しよう! ワフパス発行する"
          />
        </a>
      </Link>
    </div>
  )
}

export { CtaBanner }
